(() => {
    const $siteHeader = document.querySelector('.site-header-main');

    if (!$siteHeader) return;

    let lastScrollPos = window.scrollY;

    const initSiteHeader = () => {
        const $firstBlock = document.querySelector('.block');

        if (!$siteHeader) return;

        if ($firstBlock && $firstBlock.classList.contains('background-color-black')) {
            $siteHeader.classList.add('site-header-main--white');
        }

        setTimeout(() => {
            $siteHeader.classList.add('site-header-main--initiated');
        }, 300);
    };

    const initSiteHeaderBackground = () => {
        if (!$siteHeader) return;

        if (window.scrollY === 0) {
            $siteHeader.classList.remove('site-header-main--scrolled');
        } else {
            $siteHeader.classList.add('site-header-main--scrolled');
        }
    };

    const toggleSiteHeader = () => {
        if (window.scrollY > lastScrollPos) {
            $siteHeader.classList.add('site-header-main--hide');

            lastScrollPos = window.scrollY;
        };
        
        if (window.scrollY === 0 || window.scrollY < lastScrollPos - 100) {
            $siteHeader.classList.remove('site-header-main--hide');

            lastScrollPos = window.scrollY;
        };
    };

    window.addEventListener('scroll', () => {
        initSiteHeaderBackground();
        // toggleSiteHeader();
    });

    initSiteHeaderBackground();
    initSiteHeader();
})();
